import { createSelector } from 'reselect'
import { pick, omit, filter, reduce, isEqual } from 'lodash'
import contactLabel from 'utils/contactLabel'
import moment from 'moment'

export const emailDataSelector = state => ({
  email_messages: state.email.toValue.map((el, idx) => {
    console.log(state.email.body)
    // console.log(window.btoa(`${state.email.body}`))
    return {
      to: [el.value],
      client_id: `${idx}`,
      from: 'noreply@vasttechnologies.com',
      from_name: 'Vast Reach',
      subject: state.email.subject,
      // body: `${window.btoa(state.email.body)}`,
      body: state.email.body,
    }
  }),
})

export const contactFieldsWithoutColorsSelector = state => {
  const assignmentPoolEnabled = state.data?.['account/ap/status']?.enabled
  const fields = state.addOrEditContact.fields
  const contactWithoutColorsObject = {}
  Object.keys(fields).forEach(field => {
    if (field === 'custom_attributes') {
      contactWithoutColorsObject.custom_attributes = {}
      Object.keys(fields.custom_attributes).forEach(
        customAttribute =>
          (contactWithoutColorsObject.custom_attributes[customAttribute] =
            fields.custom_attributes[customAttribute].value),
      )
    } else if (field === 'email') {
      if (fields.email[0].value.length) {
        contactWithoutColorsObject.email = fields.email.map(el =>
          omit(
            {
              ...el,
              address: el.value,
              email_type: el.email_type ? el.email_type : 'W',
              opt_in: el.opt_in ? el.opt_in : true,
              // id: el.id,
            },
            ['color', 'value', 'initialValue'],
          ),
        )
      } else {
        return
      }
    } else if (field === 'phones') {
      if (fields.phones[0].value.length) {
        contactWithoutColorsObject.phones = fields.phones.map(el =>
          omit(
            {
              ...el,
              number: el.value,
              phone_type: el.phone_type ? el.phone_type : 'M',
              opt_in: el.opt_in ? el.opt_in : true,
              // id: el.id,
            },
            ['color', 'value', 'initialValue'],
          ),
        )
      } else {
        return
      }
    } else if (field === 'phone') {
      return
    } else {
      if (fields[field].value) {
        contactWithoutColorsObject[field] = fields[field].value
      }
    }
  })

  if (assignmentPoolEnabled) {
    return {
      ...contactWithoutColorsObject,
      vastuser:
        state.addOrEditContact?.fields?.vastuser?.value ||
        state?.auth?.session?.idToken?.payload?.['cognito:username'],
    }
  }

  return contactWithoutColorsObject
}

export const customAttributesReceivedSelector = state =>
  Object.keys(state.addOrEditContact.modal).length > 4

export const contactsWithPhoneNumbersSelector = state => {
  const contactsWithPhones = {}
  Object.keys(state.contacts.contactsWithEmailsByID).forEach(contactID => {
    const contact = state.contacts.contactsByID[contactID]
    if (contact.phone) {
      contactsWithPhones[contactID] = contact
    }
  })
  return contactsWithPhones
}

// export const contactsWithPhonesSelector = createSelector(
// 	(state) => state.contacts.contactsWithEmailsByID,
// 	(contactsWithEmailsByID) => {
// 		const array = []
// 		Object.values(contactsWithEmailsByID).forEach((contact) => {
// 			if (contact.phones && contact.phones[0].number.length) {
// 				array.push({
// 					contactID: contact.id,
// 					value: contact.id,
// 					label:
// 						contact.first_name || contact.middle_name || contact.last_name
// 							? `${contact.first_name ? `${contact.first_name} ` : ''}${
// 									contact.middle_name ? `${contact.middle_name} ` : ''
// 							  }${contact.last_name ? `${contact.last_name} ` : ''}`
// 							: contact.phones[0].number,
// 					key: `${contact.id}SelectValue`,
// 				})
// 			}
// 		})
// 		return array
// 	},
// )

export const contactsWithPhonesSelector = state =>
  Object.values(state.contacts.contactsWithEmailsByID || {}).reduce(
    (acc, contact) => {
      if (contact?.phones?.[0]?.number?.length) {
        acc.push({
          contactID: contact?.id,
          value: contact?.id,
          label:
            contact?.first_name || contact?.middle_name || contact?.last_name
              ? `${contact?.first_name ? `${contact.first_name} ` : ''}${
                  contact?.middle_name ? `${contact.middle_name} ` : ''
                }${contact?.last_name ? `${contact.last_name} ` : ''}`
              : contact?.phones?.[0]?.number,
          key: `${contact?.id}SelectValue`,
        })
      }
      return acc
    },
    [],
  )

export const contactsWithEmailsByIDSelector = createSelector(
  state => state.contacts.contactsWithEmailsByID,
  contactsWithEmailsByID =>
    Object.keys(contactsWithEmailsByID).length
      ? filter(
          contactsWithEmailsByID,
          contact => contact.email && contact.email.length,
        )
      : {},
)

// export const contactsWithEmailsSelector = state => {
//   const array = []
//   Object.keys(state.contacts.contactsWithEmailsByID).forEach(contactID => {
//     const contact = state.contacts.contactsWithEmailsByID[contactID]
//     if (contact.email && contact.email.length) {
//       contact.email.forEach(email => {
//         array.push({
//           contactID: contact.id,
//           value: email.address,
//           label: `${contact.first_name} ${contact.last_name} <${
//             email.address
//           }>`,
//           key: `${contact.id}SelectValue`,
//         })
//       })
//     }
//   })
//   return array
// }

// export const contactsWithEmailsSelector = createSelector(
// 	(state) => state.contacts.contactsWithEmailsByID,
// 	(contactsWithEmailsByID) => {
// 		const array = []
// 		Object.values(contactsWithEmailsByID).forEach((contact) => {
// 			if (contact.email && contact.email[0].address.length) {
// 				array.push({
// 					contactID: contact.id,
// 					value: contact.id,
// 					label:
// 						contact.first_name || contact.middle_name || contact.last_name
// 							? `${contact.first_name ? `${contact.first_name} ` : ''}${
// 									contact.middle_name ? `${contact.middle_name} ` : ''
// 							  }${contact.last_name ? `${contact.last_name} ` : ''}`
// 							: contact.email[0].address,
// 					key: `${contact.id}SelectValue`,
// 				})
// 			}
// 		})
// 		return array
// 	},
// )

export const contactsWithEmailsSelector = state =>
  Object.values(state.contacts.contactsWithEmailsByID || {}).reduce(
    (acc, contact) => {
      if (contact?.email?.[0]?.address?.length) {
        acc.push({
          contactID: contact?.id,
          value: contact?.id,
          label:
            contact?.first_name || contact?.middle_name || contact?.last_name
              ? `${contact?.first_name ? `${contact.first_name} ` : ''}${
                  contact?.middle_name ? `${contact.middle_name} ` : ''
                }${contact?.last_name ? `${contact.last_name} ` : ''}`
              : contact?.email?.[0]?.address,
          key: `${contact?.id}SelectValue`,
        })
      }
      return acc
    },
    [],
  )

export const groupOptionsSelector = createSelector(
  state => state.contacts.groupsByID,
  groupsByID =>
    Object.values(groupsByID)
      .map(group => ({
        groupID: group.id,
        value: group.id,
        label: `${group.name}${
          typeof group?.contact_count === 'number'
            ? ` (${group.contact_count})`
            : ''
        }`,
        key: `${group.id}GroupSelectValue`,
        contact_count: group?.contact_count,
      }))
      .sort((a, b) => {
        const nameA = a.label.toUpperCase()
        const nameB = b.label.toUpperCase()
        if (nameA > nameB) {
          return 1
        }
        if (nameA < nameB) {
          return -1
        }
        return 0
      }),
)

export const contactOptionsSelector = createSelector(
  state => state.contacts.contactsWithEmailsByID,
  contactsByID =>
    Object.values(contactsByID)
      .map(contact => ({
        contactID: contact.id,
        value: contact.id,
        label: contactLabel(contact),
        key: `${contact.id}ContactSelectValue`,
      }))
      .sort((a, b) => {
        const nameA = a.label.toUpperCase()
        const nameB = b.label.toUpperCase()
        if (nameA > nameB) {
          return 1
        }
        if (nameA < nameB) {
          return -1
        }
        return 0
      }),
)

export const contactsWithEmailsSelector2 = state =>
  reduce(
    state.contacts.contactsWithEmailsByID,
    (res, contact, contactID) => {
      if (contact.email && contact.email.length) {
        res.push({
          contactID,
          value: contactID,
          label: `${contactLabel(contact)} ${contact.email.map(
            email => `<${email.address}>`,
          )}`,
          key: `${contactID}SelectValue`,
        })
      }
      return res
    },
    [],
  )

export const contactsWithEmailsByIDSelector2 = state =>
  reduce(
    state.contacts.contactsWithEmailsByID,
    (res, contact, contactID) => {
      res[contactID] = {
        contactID,
        value: contactID,
        label: `${contactLabel(contact)}`,
        key: `${contactID}SelectValue`,
      }
      // if (contact.email && contact.email[0].address.length) {
      // }
      return res
    },
    {},
  )

export const contactsWithPhonesByIDSelector = state =>
  Object.keys(state.contacts.contactsWithEmailsByID).length
    ? filter(
        state.contacts.contactsWithEmailsByID,
        contact => contact.phones && contact.phones[0].length,
      )
    : {}

export const groupsByID2 = state =>
  reduce(
    state.contacts.groupsByID,
    (res, group, groupID) => {
      res[groupID] = {
        groupID,
        value: groupID,
        label: `${group.name}`,
        key: `${groupID}GroupSelectValue`,
      }
      return res
    },
    {},
  )

export const createContactSpeedDialEnabledSelector = state => {
  const { first_name, last_name, email } = state.addOrEditContact.fields
  return first_name.value !== '' && last_name.value !== '' && email.value !== ''
}

// export const contactsInGroupSelector = (groupID, state) => {
// 	return groupID &&
// 		Object.keys(state.contacts.groupsByID).length &&
// 		Object.keys(state.contacts.contactsWithEmailsByID).length &&
// 		state.contacts.groupsByID[groupID] &&
// 		state.contacts.groupsByID[groupID].memberIDs
// 		? pick(
// 				state.contacts.contactsWithEmailsByID,
// 				Object.keys(state.contacts.groupsByID[groupID].memberIDs),
// 		  )
// 		: {}
// }

export const contactsInGroupSelector = createSelector(
  state => state.contacts.contactsWithEmailsByID,
  state => state.addOrEditContact.memberIDs,
  (contactsWithEmailsByID, memberIDs) =>
    pick(contactsWithEmailsByID, memberIDs),
)

// export const contactsNotInGroupSelector = (groupID, state) =>
//   groupID !== null &&
//   state.contacts.groupsByID[groupID] &&
//   state.contacts.groupsByID[groupID].memberIDs
//     ? omit(
//         state.contacts.contactsWithEmailsByID,
//         Object.keys(state.contacts.groupsByID[groupID].memberIDs),
//       )
//     : {}

export const contactsNotInGroupSelector = createSelector(
  state => state.contacts.contactsWithEmailsByID,
  state => state.addOrEditContact.memberIDs,
  (contactsWithEmailsByID, memberIDs) =>
    omit(contactsWithEmailsByID, memberIDs),
)

const smartTaskFieldSelector = state => state.tasks.addOrEdit.fields.smartTask
const selectedActionPredictionSelector = state =>
  state.tasks.addOrEdit.fields.selectedActionPrediction
const dateFieldSelector = state => state.tasks.addOrEdit.fields.date
const selectSelector = state => state.tasks.addOrEdit.select
const templateNameSelector = state => state.email.templateName
const subjectSelector = state => state.email.subject
const fromNumberSelector = state => state.tasks.addOrEdit.fromNumberSelected

export const taskFormChangesSelector = createSelector(
  smartTaskFieldSelector,
  selectedActionPredictionSelector,
  dateFieldSelector,
  selectSelector,
  templateNameSelector,
  subjectSelector,
  fromNumberSelector,
  (
    smartTaskField,
    selectedActionPrediction,
    dateField,
    select,
    templateName,
    subject,
    fromNumber,
  ) => {
    const dateValue = moment(dateField.value)
    const dateValueValid = dateValue && dateValue.isValid()
    const initialDateValue = moment(dateField.initialValue)
    const initialDateValueValid = initialDateValue && initialDateValue.isValid()

    const dateChanged = () => {
      if (dateValueValid) {
        if (initialDateValueValid) {
          return !dateValue.isSame(initialDateValue)
        } else {
          return true
        }
      } else {
        return initialDateValueValid
      }
    }

    if (smartTaskField.value !== smartTaskField.initialValue) {
      return true
    } else if (
      selectedActionPrediction.value !== selectedActionPrediction.initialValue
    ) {
      return true
    } else if (dateChanged()) {
      return true
    } else if (!isEqual(select.value, select.initialValue)) {
      return true
    } else if (!isEqual(fromNumber.value, fromNumber.initialValue)) {
      return true
    } else if (templateName.value !== templateName.initialValue) {
      return true
    } else if (subject.value !== subject.initialValue) {
      return true
    }
    return false
  },
)

export const saveButtonDisabledSelector = createSelector(
  state => state.tasks.addOrEdit.select.value,
  state => state.tasks.addOrEdit.fields.date.value,
  state => state.tasks.addOrEdit.fields.selectedActionPrediction.value,
  state => state.email.templateName.value,
  state => state.email.subject.value,
  // state => state.tasks.addOrEdit.automationTypeSelected,
  (
    selectValue,
    dateValue,
    selectedActionPrediction,
    templateName,
    subject /* , automationTypeSelected */,
  ) => {
    if (selectedActionPrediction === 'email') {
      return (
        !templateName.length ||
        !subject.length ||
        !selectValue.length ||
        !dateValue
      )
    }
    return !selectValue.length || !dateValue
  },
)

export const templateSelector = createSelector(
  state => state.email.templateName.value,
  state => state.email.subject.value,
  // (state) => state.email.body,
  state => state.email.sections,
  state => state.email.defaultValues,
  state => state.email.templateID,
  state => state.email.colors.background,
  state => state.email.textAlign,
  state => state.email.themeSelected,
  state => state.email.colors.foreground,
  (
    name,
    SubjectPart,
    sections,
    defaultValues,
    id,
    background,
    textAlign,
    themeSelected,
    foreground,
  ) => {
    const sectionsString =
      sections?.reduce((acc, el) => {
        acc += el.value
        return acc
      }, '') || ''

    const newValues = sectionsString
      ?.match(/{{[^{}]+}}/g)
      ?.reduce((acc, el) => {
        const str = el.slice(2, -2).trim()
        if (str) {
          acc[el.slice(2, -2).trim()] = ''
        }
        return acc
      }, {})

    const default_template_values = {
      ...(newValues || {}),
      ...defaultValues,
    }

    const firstString = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd"><html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: 'Avenir Next', 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><meta name="viewport" content="width=device-width"/>${
      themeSelected
        ? `<meta class="vastreach-theme" data-vast-theme="${themeSelected}"/>`
        : ''
    }</head><body align="center" style="margin: 0;padding:0;background: #ffffff;"><div class="background" style="background: ${background};"><div class="foreground" style="max-width: 600px;background: ${foreground};"><table style="max-width: 600px;margin: 0 auto 0;padding: 0 0 40px 0;text-align: ${textAlign};background: transparent;border-radius: .35rem;border-spacing: 0;">`
    const secondString = '</table></div></div></body></html>'

    const template = {
      Template: {
        SubjectPart,
        HtmlPart: `${firstString}${sections.reduce((acc, section) => {
          acc += `<tr><td class="vastreach-sections" data-vast-editor="${section.editor}" style="padding: ${ section.editor === "paragraph" ? "8px" : "0"};">${section.value}</td></tr>`
          return acc
        }, '')}${secondString}`,
        TextPart: '',
      },
      name,
    }

    // console.log(template.Template.HtmlPart)

    if (id !== 'new') {
      return Object.values(default_template_values).length
        ? {
            ...template,
            default_template_values,
            id,
          }
        : {
            ...template,
            id,
          }
    }

    return Object.values(default_template_values).length
      ? { ...template, default_template_values }
      : template
  },
)

export const azSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    }),
)

export const zaSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    }),
)

export const newestFirstSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).sort((a, b) => {
      const dateA = new Date(a.when_created)
      const dateB = new Date(b.when_created)
      if (dateA < dateB) return 1
      if (dateA > dateB) return -1
      return 0
    }),
)

export const oldestFirstSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).sort((a, b) => {
      const dateA = new Date(a.when_created)
      const dateB = new Date(b.when_created)
      if (dateA > dateB) return 1
      if (dateA < dateB) return -1
      return 0
    }),
)

export const totalVisitsSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).reduce((visits, form) => {
      if (form.stats) {
        visits += form.stats.visits
      }
      return visits
    }, 0),
)

export const totalResponsesSelector = createSelector(
  state => state.signupForm.forms,
  forms =>
    Object.values(forms).reduce((visits, form) => {
      if (form.stats) {
        visits += form.stats.submissions
      }
      return visits
    }, 0),
)

// export const saveTaskSelector = createSelector(
//   state => state.tasks.addOrEdit.defaultValues,
//   state => state.tasks.addOrEdit.emailEditor,
//   state => state.tasks.addOrEdit.fields.smartTask.value,
//   state => state.tasks.addOrEdit.fields.selectedActionPrediction.value,
//   state => state.tasks.addOrEdit.fields.date.value,
//   state => state.tasks.addOrEdit.select.value,
//   state => state.tasks.addOrEdit.selectedTemplate.value,
//   state => state.tasks.addOrEdit.sms.value, // change this!!!
//   state => state.tasks.addOrEdit.subject.value,
//   state => state.tasks.addOrEdit.taskID,
//   (
//     defaultValues,
//     emailEditor,
//     description,
//     selectedActionPrediction,
//     date,
//     select,
//     selectedTemplate,
//     sms,
//     subject,
//     taskID,
//   ) => {
//     const sendType = selectedActionPrediction === 'email' ? 'send_email' : 'send_sms'
//     const task_type_id = selectedActionPrediction === 'email' ? '1' : '2'
//     const trigger_data = selectedActionPrediction === 'email' ?
//       {} :
//       {}
//     return {
//       description,
//       task_type_id,
//       [sendType]: {
//         when_to_send: date.toISOString(),
//         trigger_data: {

//         }
//       }
//     }
//   }
// )
